export const getDate = (date = "") => {
  if (date !== null)
    return typeof date.replaceAll == "function"
      ? date.replaceAll(/,/g, ".")
      : "";

  return "1.1.2022";
};
